import { IconButton, styled, Typography } from '@mui/material';

export const RowW = styled('div')`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 2fr auto;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  gap: 12px;
  cursor: pointer;

  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }

  @media (max-width: 1023px) {
    grid-template-columns: 1fr auto;
    row-gap: 4px;
  }
`;

export const NameCellW = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const FileName = styled(Typography)`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CellText = styled(Typography)`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p040};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const ActionsCell = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const StarBtnW = styled(IconButton)`
  padding: 4px;
`;

export const ThreeDotsBtnW = styled(IconButton)`
  padding: 4px;
`;
